import React from "react";
// import { PieChart, Pie, Cell } from "recharts";

// const pieData1 = [
//   { name: "Segment 1", value: 20, color: "#1E40AF" },
//   { name: "Segment 2", value: 30, color: "#3B82F6" },
//   { name: "Segment 3", value: 50, color: "#22C55E" }
// ];

// const pieData2 = [
//   { name: "Segment 1", value: 20, color: "#2563EB" },
//   { name: "Segment 2", value: 25, color: "#60A5FA" },
//   { name: "Segment 3", value: 25, color: "#60A5FA" },
//   { name: "Segment 4", value: 30, color: "#16A34A" }
// ];

const SoftEstimateLogo = () => {
    return (
        <div className="flex flex-col items-center font-extrabold text-5xl relative">
            <div className="flex items-center">
                {/* Soft in Green */}
                <span className="text-green-600 mr-2">Soft</span>

                {/* E as a Bar Chart with two colors, vertical line, and more spacing */}
                {/* <span className="relative flex flex-col items-center w-10 h-14"> 
                <div className="absolute left-0 w-2 h-12 bg-gray-700"></div> 
                <div className="w-6 h-3 flex mb-2 relative"> 
                    <span className="absolute text-white text-[7px] font-extrabold left-1/2 transform -translate-x-1/2 -translate-y-1/2">50%</span>
                    <div className="w-1/2 h-full bg-blue-600"></div>
                    <div className="w-1/2 h-full bg-blue-400"></div>
                </div>
                <div className="w-3 h-3 flex mb-2 relative"> 
                    <span className="absolute text-white text-[7px] font-extrabold left-1/2 transform -translate-x-1/2 -translate-y-1/2">30%</span>
                    <div className="w-1/2 h-full bg-blue-400"></div>
                    <div className="w-1/2 h-full bg-blue-600"></div>
                </div>
                <div className="w-6 h-3 flex mb-2 relative">
                    <span className="absolute text-white text-[7px] font-extrabold left-1/2 transform -translate-x-1/2 -translate-y-1/2">40%</span>
                    <div className="w-1/2 h-full bg-blue-600"></div>
                    <div className="w-1/2 h-full bg-blue-400"></div>
                </div>
            </span> */}

            {/* stim with Dollar Sign */}
            {/* <span className="text-blue-600">$</span>
        <span className="text-blue-600 italic">ti</span>      
        <span className="text-blue-600 mr-2">mate</span> */}
            <span className="text-blue-600">Estimate</span>

            {/* 8 as Multiple Vertical Pie Charts (Further Reduced Size)*/}
            {/* <div className='flex flex-col items-center w-1 h-2 relative -mt-2'>
                <PieChart width={20} height={20}>
                    <Pie data={pieData1} dataKey="value" cx="50%" cy="50%" innerRadius={5} outerRadius={12}>
                        {pieData1.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
                <PieChart width={20} height={20}>
                    <Pie data={pieData2} dataKey="value" cx="50%" cy="50%" innerRadius={5} outerRadius={12}>
                        {pieData2.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
            </div> */}
        </div>
      {/* Slogan */ }
    <div className="mt-2 text-lg text-gray-600 font-semibold border-t-2 border-gray-400 pt-2 w-full text-center">
        <span className="text-blue-600">Plan Right, </span>
        <span className="text-green-600">Build Better! </span>
        <span className="text-blue-600">Estimate Smarter, </span>
        <span className="text-green-600">Grow Faster!</span>
    </div>
    </div >
  );
};

export default SoftEstimateLogo;
